import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReportGmailerrorredIcon(props: IconProps) {
    return <Icon {...props} iconKey={"report_gmailerrorred"}/>
}
